import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export interface WaypointMenuTarget { id: string; number: number; button: HTMLElement; label?: string }

export function WaypointMenu({ target, onDelete, onClose, deletionLabel = 'keyframe' }: {
  deletionLabel?: string;
  target: WaypointMenuTarget; onDelete: (id: string) => void; onClose: () => void;
}) {
  const menu = useRef<HTMLDivElement>(null);
  const close = useRef(onClose); close.current = onClose;
  useEffect(() => {
    menu.current?.querySelector('button')?.focus();
    const outside = (event: Event) => {
      if (!menu.current?.contains(event.target as Node) && !target.button.contains(event.target as Node)) close.current();
    };
    const dismiss = () => close.current();
    document.addEventListener('pointerdown', outside, true);
    document.addEventListener('scroll', dismiss, true);
    window.addEventListener('resize', dismiss);
    return () => {
      document.removeEventListener('pointerdown', outside, true);
      document.removeEventListener('scroll', dismiss, true);
      window.removeEventListener('resize', dismiss);
    };
  }, [target]);
  const rect = target.button.getBoundingClientRect();
  return createPortal(<div ref={menu} className="prototype-waypoint-menu" role="menu"
    aria-label={`${target.label ?? `Keyframe ${target.number}`} options`} data-theme={target.button.closest('[data-theme]')?.getAttribute('data-theme')}
    style={{ left: Math.max(8, Math.min(innerWidth - 188, rect.left)), top: Math.max(8, Math.min(innerHeight - 64, rect.bottom + 6)) }}
    onKeyDown={event => {
      event.stopPropagation();
      if (event.key === 'Escape' || event.key === 'Tab') { event.preventDefault(); onClose(); target.button.focus(); }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') event.preventDefault();
    }}>
    <button type="button" role="menuitem" onClick={() => { onDelete(target.id); onClose(); }}>
      Delete {target.label ?? `${deletionLabel} ${target.number}`}
    </button>
  </div>, document.body);
}
